import { useMemo } from 'react';
import type { ResidentNotificationPayload } from '@caro/shared/types';
import { useTranslation } from './useTranslation';
import {
  localizeNotification,
  type LocalizedNotificationText,
} from '../services/notificationLanguage';

/**
 * De tekst van een melding in de taal van deze bewoner (specs/20261016-taal-bewonersapp,
 * T033/T035b). Eerst een systeemsleutel, dan de taalketen. Herberekent bij een taalwissel,
 * zodat een melding die al op het scherm staat meewisselt (wens 4).
 */
export function useLocalizedNotification(
  payload: ResidentNotificationPayload | null | undefined,
): LocalizedNotificationText | null {
  const { lang } = useTranslation();
  return useMemo(() => (payload ? localizeNotification(payload, lang) : null), [payload, lang]);
}
